import { styled } from '@mui/material';
import { palette } from 'view/themes/palette';
import Select from '@mui/material/Select';

export const Wrapper = styled('div')<{ marginbottom?: number }>(({ marginbottom = 24 }) => {
  return {
    marginBottom: `${marginbottom}px`,
  };
});

export const Label = styled('label')<{ hasError?: boolean }>(({ hasError }) => {
  return {
    display: 'block',
    color: hasError ? palette.alerts.error : palette.text.header,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '21px',
    marginBottom: '7px',
  };
});

export const InputRow = styled('div', {
  shouldForwardProp: (prop) => {
    return prop !== 'hasError';
  },
})<{ hasError?: boolean }>(({ hasError }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    minHeight: '40px',
    border: `1px solid ${hasError ? palette.alerts.error : palette.border.default}`,
    borderRadius: '8px',
    overflow: 'hidden',
    '&:hover': {
      borderColor: hasError ? palette.alerts.error : palette.hover.brand,
    },
    '&:focus-within': {
      borderColor: hasError ? palette.alerts.error : palette.primary.purple500,
    },
  };
});

export const CountrySelect = styled(Select)({
  padding: '8px !important',
  fontSize: '14px',
  color: palette.text.body,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  flexShrink: 0,
  minHeight: '40px',
  border: 'none',
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderRight: `1px solid ${palette.border.default}`,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderRight: `1px solid ${palette.border.default}`,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderRight: `1px solid ${palette.border.default}`,
  },
});

export const NumberInput = styled('input')({
  border: 'none',
  outline: 'none',
  flex: 1,
  padding: '8px 12px',
  fontSize: '14px',
  color: palette.text.body,
  backgroundColor: 'transparent',
  '&::placeholder': {
    color: palette.text.placeholder,
  },
});

export const ErrorText = styled('p')({
  margin: '3px 0 0',
  fontSize: '12px',
  color: palette.alerts.error,
  fontFamily: 'inherit',
});
